import { render } from "./settings.vue?vue&type=template&id=7f2bb70d&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=7f2bb70d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2bb70d"]])

export default __exports__